<list-view *ngIf="listeEnergies" [liste]="listeEnergies"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>